// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nZYI","importantInfo":"styles_importantInfo__3XQ_V"};